<template>
  <component :is="layoutComponent" />
</template>

<script>
import StandardLayout from './layouts/StandardLayout.vue'
import EditorialLayout from './layouts/EditorialLayout.vue'
import GalleryLayout from './layouts/GalleryLayout.vue'
import HeroLayout from './layouts/HeroLayout.vue'
import CardsLayout from './layouts/CardsLayout.vue'

const LAYOUT_MAP = {
  standard: StandardLayout,
  editorial: EditorialLayout,
  gallery: GalleryLayout,
  hero: HeroLayout,
  cards: CardsLayout
}

export default {
  name: 'CmsLayoutResolver',
  components: {
    StandardLayout,
    EditorialLayout,
    GalleryLayout,
    HeroLayout,
    CardsLayout
  },
  inject: ['front'],
  computed: {
    layoutComponent() {
      const code = String(this.front.layoutCode || 'standard').toLowerCase()
      return LAYOUT_MAP[code] || StandardLayout
    }
  }
}
</script>
